import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";
import { secondsToMinutesAndSeconds } from "../../../helpers/MathHelpers";

export default observer(function TimeDetails() {
  const { videoProgress, videoDuration } = videoPlayerService;

  const currentTime = useMemo(() => secondsToMinutesAndSeconds(videoProgress), [videoProgress]);
  const totalTime = useMemo(() => secondsToMinutesAndSeconds(videoDuration), [videoDuration]);

  return (
    <div className="video-time-details">
      {currentTime}/{totalTime}
    </div>
  );
});
